import React from 'react';

import { useResponsive } from '@/hooks/useResponsive';

import type { CTASectionProps } from '../../../types';
import SmartDownloadIcon from '../../Icons/SmartDownloadIcon';
import styles from './index.module.css';

export const CTASection: React.FC<CTASectionProps> = ({
  title = '准备好一起 CodeFlicker 了吗？',
  downloadText = '下载',
  allDownloadText = '下载全部',
  onDownloadClick,
  onAllDownloadClick,
  className,
  recommendedType,
}) => {
  const { isMobile } = useResponsive();
  return (
    <section
      className={`${styles.ctaSection} ${isMobile ? styles.mobileCtaSection : ''} ${className || ''}`}
    >
      <div className={`${styles.container} ${isMobile ? styles.mobileContainer : ''}`}>
        <h2 className={`${styles.title} ${isMobile ? styles.mobileTitle : ''}`}>{title}</h2>

        <div className={`${styles.buttonGroup} ${isMobile ? styles.mobileButtonGroup : ''}`}>
          <button
            className={`${styles.downloadButton} ${isMobile ? styles.mobileDownloadButton : ''}`}
            onClick={onDownloadClick}
            type="button"
          >
            <SmartDownloadIcon className={styles.downloadIcon} recommendedType={recommendedType} />
            <span>{downloadText}</span>
          </button>

          <button
            className={`${styles.allDownloadButton} ${isMobile ? styles.mobileAllDownloadButton : ''}`}
            onClick={onAllDownloadClick}
            type="button"
          >
            <span>{allDownloadText}</span>
          </button>
        </div>
      </div>
    </section>
  );
};
